/* Position a slide CTA against the displayed image, including object-fit cropping. */
if (!customElements.get('aurlona-banner-button')) {
  customElements.define('aurlona-banner-button', class extends HTMLElement {
    connectedCallback() {
      this.slide = this.closest('.hdt-slide_inner');
      this.image = this.slide?.querySelector('.hdt-media-wrapper img');
      if (!this.image) {
        this.setAttribute('data-positioned', '');
        return;
      }
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.positionButton());
      };
      this.breakpoint = matchMedia('(max-width: 767px)');
      this.breakpoint.addEventListener('change', this.schedule);
      this.image.addEventListener('load', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.slide);
      this.observer.observe(this);
      this.positionButton();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.image?.removeEventListener('load', this.schedule);
      this.breakpoint?.removeEventListener('change', this.schedule);
    }

    positionButton() {
      if (!this.isConnected || !this.offsetParent) return;
      // Shopify supplies the original dimensions for both desktop and mobile.
      // Use them before the image downloads, and keep the same ratio after load.
      const source = [...(this.image.closest('picture')?.querySelectorAll('source[media]') || [])]
        .find(item => matchMedia(item.getAttribute('media')).matches);
      const dimensions = source || this.image;
      const declaredWidth = Number(dimensions.getAttribute('width'));
      const declaredHeight = Number(dimensions.getAttribute('height'));
      const intrinsicWidth = declaredWidth && declaredHeight ? declaredWidth : this.image.naturalWidth;
      const intrinsicHeight = declaredWidth && declaredHeight ? declaredHeight : this.image.naturalHeight;
      if (!intrinsicWidth || !intrinsicHeight) return;
      const imageBox = this.image.getBoundingClientRect();
      const parentBox = this.offsetParent.getBoundingClientRect();
      const buttonBox = this.getBoundingClientRect();
      if (!imageBox.width || !imageBox.height) return;
      const imageStyle = getComputedStyle(this.image);
      const ratios = [imageBox.width / intrinsicWidth, imageBox.height / intrinsicHeight];
      const scale = imageStyle.objectFit === 'contain' ? Math.min(...ratios) : Math.max(...ratios);
      const renderedWidth = intrinsicWidth * scale;
      const renderedHeight = intrinsicHeight * scale;
      const focal = imageStyle.objectPosition.split(/\s+/).map(value => value.endsWith('%') ? parseFloat(value) / 100 : 0.5);
      const mobile = this.breakpoint.matches;
      const x = Number(mobile ? this.dataset.mobileX : this.dataset.desktopX) / 100;
      const y = Number(mobile ? this.dataset.mobileY : this.dataset.desktopY) / 100;
      // Desktop aligns the left edge with the copy; mobile aligns the button center.
      const left = (imageBox.width - renderedWidth) * (focal[0] ?? 0.5) + renderedWidth * x - (mobile ? buttonBox.width / 2 : 0);
      const top = (imageBox.height - renderedHeight) * (focal[1] ?? 0.5) + renderedHeight * y;
      const boundedLeft = Math.max(12, Math.min(left, imageBox.width - buttonBox.width - 12));
      const boundedTop = Math.max(12, Math.min(top, imageBox.height - buttonBox.height - 12));
      this.style.left = `${imageBox.left - parentBox.left + boundedLeft}px`;
      this.style.top = `${imageBox.top - parentBox.top + boundedTop}px`;
      this.setAttribute('data-positioned', '');
    }
  });
}
